module.exports = __webpack_public_path__ + "static/media/바.5273a269.jpg";